<script>
  import { Tooltip } from 'element-ui'
  export default {
    name:'ElTooltip',
    extends:Tooltip
  }
</script>
